import React from 'react';
const InputComponent = (props) => {
    return (
        <input {...props.formData} />
    );
}
 
export default InputComponent;